import {FirestoreStructuredData} from "./structured-data/firestore-structured-data";
import {Blog} from "../blog/blog-domain";

export abstract class SeoService {

  abstract setTagsForHomepage(firestoreStructuredData: FirestoreStructuredData): void;

  abstract setTagsForBlog(firestoreStructuredData: FirestoreStructuredData,
                          posts: Blog.PostHeader[]): void

  abstract setTagsForBlogPost(firestoreStructuredData: FirestoreStructuredData,
                              postData: Blog.Post): void

  abstract getFirestoreStructuredData(): Promise<FirestoreStructuredData>;

}
